import React, { useState, useEffect, useRef } from "react";
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import './SummaryOfMonthly.css';
import { jsPDF } from "jspdf";  // Import jsPDF
import "jspdf-autotable";
import pds from './pds.PNG';
import Select from 'react-select'; // Import react-select
import { format } from 'date-fns';
import ExcelJS from 'exceljs';

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const SummaryOfMonthly = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const sortData = (data) => {
        return data.sort((a, b) => {
            const districtA = a.fairPriceShopDetails.district || '';
            const districtB = b.fairPriceShopDetails.district || '';
            const subDivisionA = a.fairPriceShopDetails.subDivision || '';
            const subDivisionB = b.fairPriceShopDetails.subDivision || '';
            const blockA = a.fairPriceShopDetails.block || '';
            const blockB = b.fairPriceShopDetails.block || '';
            const panchayatA = a.fairPriceShopDetails.panchayat.trim() || '';
            const panchayatB = b.fairPriceShopDetails.panchayat.trim() || '';

            // Sorting order: first district, then sub-division, then block, and finally panchayat
            if (districtA < districtB) return -1;
            if (districtA > districtB) return 1;
            if (subDivisionA < subDivisionB) return -1;
            if (subDivisionA > subDivisionB) return 1;
            if (blockA < blockB) return -1;
            if (blockA > blockB) return 1;
            if (panchayatA < panchayatB) return -1;
            if (panchayatA > panchayatB) return 1;
            return 0;
        });
    };

    const [dataAvailable, setDataAvailable] = useState(false);  // New state for checking if data is available
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 25;
    // Sorted data before rendering
    const sortedData = sortData(data);
    // Calculate the index range for the current page
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    const currentRecords = sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
    // Ensure sortedData is properly passed and initialized
    useEffect(() => {
        if (sortedData.length > 0) {
            setDataAvailable(true);  // Set dataAvailable to true if data is available
        }
    }, [sortedData]);
    const [districtUid, setDistrictUid] = useState(''); // Store districtUid for reports
    const [subDivisionUid, setSubDivisionUid] = useState(''); // Store subdistrictUid for reports
    const [blockUid, setBlockUid] = useState(' ');
    const [panchayatUid, setPanchayatUid] = useState(' ');
    const [showTable, setShowTable] = useState(false);
    //  const [reportData, setReportData] = useState([]);
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);
    // const [fpsId, setFpsId] = useState("");  // Ensure this is defined at the top of your component
    const [inspectionOfficerId, setInspectionOfficerId] = useState(null);
    const [inspectionOfficers, setInspectionOfficers] = useState([]);
    const [designationName, setDesignationName] = useState('');
    const [officerDesignation, setOfficerDesignation] = useState('');
    const [username, setUserName] = useState('');
    const [poimsUserId, setId] = useState('');
    const [id, setUserId] = useState('');

    const [error, setError] = useState(null);  // Define setError here
    const [isLoading, setIsLoading] = useState(false);

    //const [showDownloadPdf, setShowDownloadPdf] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [stockData, setStockData] = useState([]);


    const reportRef = useRef(null);  // Reference to the report HTML
    const [isOpen, setIsOpen] = useState(false); // To control dropdown open/close
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    // Determine the minimum date for the endDate date picker
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(2025, 0, 1); // January 1st of current year
    // Handle "Next" button click
    const nextPage = () => {
        if (currentPage < Math.ceil(sortedData.length / recordsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    // Handle "Previous" button click
    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const generatePDF = () => {
        const doc = new jsPDF({
            unit: 'mm', // units in mm (millimeters)
            format: [210, 260] // A4 size: 210mm x 297mm (you can customize it to larger size like letter: [216, 279])
        });

        doc.setFontSize(18);
        doc.addImage(pds, 'jpeg', 9.5, 10, 190, 30);  // Image format: 'PNG'
        // Assuming doc is an instance of jsPDF

        const pageWidth = doc.internal.pageSize.width;

        // Set the background color for the title and move it down
        const backgroundYPosition = 40.2; // New y-position for the background fill
        doc.setFillColor(211, 211, 211); // RGB values for 'whitesmoke'
        doc.rect(10, backgroundYPosition, pageWidth - 20, 15, 'F'); // Draw a filled rectangle with the new y-position

        // Set the report title with a styled color
        const title = 'Summary of Monthly Inspection Report';  // Title for the report

        // Get the page width
        const titleWidth = doc.getTextWidth(title); // Get the width of the title

        // Set title text color to #2a6d8b
        doc.setTextColor(42, 109, 139);  // RGB values for #2a6d8b
        doc.setFontSize(14.4);

        // Increase the y-position to move the title further down
        const titleYPosition = backgroundYPosition + 10; // Adjusted y-position for the title, below the background

        // Draw the title text in the center of the page
        doc.text(title, (pageWidth - titleWidth) / 2, titleYPosition); // Position the title at the new y position
        // Get the current date

        // Mapping IDs to names for each field
        const district = districts.find(d => String(d.id) === String(districtId));
        const subDivision = subDivisions.find(s => String(s.id) === String(subDivisionId));
        const block = blocks.find(b => String(b.id) === String(blockId));
        const panchayat = panchayats.find(p => String(p.id) === String(panchayatId));
        //  const fps = fpshops.find(f => String(f.id) === String(fpsId));
        //const fullName = fullname.find(f => String(f.id) === String(id));
        const districtName = district ? district.districtName : '';
        const subDivisionName = subDivision ? subDivision.subDivisionName : '';
        const blockName = block ? block.blockName : '';
        const panchayatName = panchayat ? panchayat.panchayatName : '';
        //  const fpsName = fps ? fps.fpsId : '';
        // Access fullname directly from your payload (data variable)
        // Assuming 'data' is an array containing objects with 'fullname' as one of the properties
        const userFullname = data && data[0] ? data[0].fullName : ' ';  // Use fullName, not fullname
        // console.log("User Fullname: ", userFullname);  // Log to check the output

        // Date formatting (if dates are present)
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        // Set the font size and text color for the content
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);  // Set text color to black

        // table td height define for y and x is moving rightside
        let currentYPosition = 55.21;
        let xPosition = 10;

        // Define the space between columns
        const columnSpacing = 63.2; // Space between columns

        // Draw the first table (District, Sub Division, Block, etc.)
        const tableHeight = 8;  // Row height for each line
        const tableWidth = columnSpacing * 3;  // Table width based on the number of columns

        // Draw table headers with borders between columns (only if data exists)
        doc.rect(xPosition, currentYPosition, tableWidth, tableHeight);  // Top border of the table

        // Set font to normal for labels (District:, Sub Division:, Block:)
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);  // Set text color to black for labels

        let hasDistrict = districtName !== '';
        let hasSubDivision = subDivisionName !== '';
        let hasBlock = blockName !== '';

        // Add labels only if data exists for the fields
        if (hasDistrict) {
            doc.text("District:", xPosition + 5, currentYPosition + 5);
        }
        if (hasSubDivision) {
            doc.text("Sub Division:", xPosition + 15 + columnSpacing, currentYPosition + 5);
        }
        if (hasBlock) {
            doc.text("Block:", xPosition + columnSpacing * 2.25, currentYPosition + 5);
        }

        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);  // Blue color for dynamic data

        // Add dynamic data only if the corresponding field exists
        if (hasDistrict) {
            doc.text(capitalizeFirstLetter(districtName), xPosition + 28, currentYPosition + 5);  // District name (dynamic)
        }
        if (hasSubDivision) {
            doc.text(capitalizeFirstLetter(subDivisionName), xPosition + columnSpacing * 1.65, currentYPosition + 5);  // Sub Division name (dynamic)
        }
        if (hasBlock) {
            doc.text(capitalizeFirstLetter(blockName), xPosition + columnSpacing * 2.02 + 28, currentYPosition + 5);  // Block name (dynamic)
        }

        // Add borders for each column only if the corresponding field is present
        // if (hasSubDivision) doc.line(xPosition + columnSpacing - 3, currentYPosition, xPosition + columnSpacing - 3, currentYPosition + tableHeight); // Border between columns
        // if (hasBlock) doc.line(xPosition + columnSpacing * 2, currentYPosition, xPosition + columnSpacing * 2, currentYPosition + tableHeight); // Border between columns

        // Add the first row data
        currentYPosition += tableHeight;  // Move down for the next row

        // Draw the second table (Panchayat, FPS ID, Dates)
        const tableHeight2 = 8;  // Row height for each line
        const tableWidth2 = columnSpacing * 3;  // Table width for this table

        currentYPosition += tableHeight - 8;  // Add some space between the two tables

        // Draw second table (Panchayat, FPS ID) only if data exists
        let currentTableHeight = 0;
        if (panchayatName || poimsUserId) {
            // Second table - Panchayat and FPS ID

            doc.rect(xPosition, currentYPosition, tableWidth2, tableHeight2);  // Top border of the second table

            // Set font to normal for labels (Panchayat, FPS ID)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            let hasPanchayat = panchayatName !== '';
            let hasFullname = userFullname !== '';

            // Add labels only if data exists
            if (hasPanchayat) {
                doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
            }
            if (hasFullname) {
                doc.text("Inspection Officer:", xPosition + columnSpacing * 1.42, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Green color for dynamic data

            // Add dynamic data only if the corresponding field exists
            if (hasPanchayat) {
                let firstName = panchayatName;
                doc.text(capitalizeFirstLetter(firstName), xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
            }
            if (hasFullname) {
                doc.text(capitalizeFirstLetter(userFullname), xPosition + columnSpacing + 61, currentYPosition + 5);  // FPS ID (dynamic)
            }

            // Add borders for each column only if the corresponding field exists
            //if (hasFullname) doc.line(xPosition + columnSpacing - 3, currentYPosition, xPosition + columnSpacing - 3, currentYPosition + tableHeight2); // Border between columns

            // Move down for the next row
            currentYPosition += tableHeight2;
            currentTableHeight = tableHeight2; // Update table height for the second table
        }

        // Check if the second table doesn't have data, then directly show third table (From Date, To Date)
        const tableHeight3 = 8;  // Row height for the third table
        const hasFromDate = fromDate !== '';
        const hasToDate = toDate !== '';

        if (!currentTableHeight || hasFromDate || hasToDate) {
            // Third table - From Date and To Date (show this table if second table is empty or if third table data exists)
            doc.rect(xPosition, currentYPosition, tableWidth2, tableHeight3);  // Top border of the third table

            // Set font to normal for labels (From Date, To Date)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels for From Date and To Date
            if (hasFromDate) {
                doc.text("From Date:", xPosition + 5, currentYPosition + 5);
            }
            if (hasToDate) {
                doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

            // Add dynamic data for From Date and To Date
            if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
            if (hasToDate) doc.text(toDate, xPosition + columnSpacing * 1.55, currentYPosition + 5);  // To Date (dynamic)

            // Add borders for each column only if the corresponding field exists
            // if (hasToDate) doc.line(xPosition + columnSpacing - 3, currentYPosition, xPosition + columnSpacing - 3, currentYPosition + tableHeight3); // Border between columns

            // Move down for the next row (third table row)
            currentYPosition += tableHeight3;
        } else {
            // If second table has data, make room for third table after second table data
            currentYPosition += currentTableHeight;
        }
        currentYPosition += 5;  // Adjust space for next content if needed

        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, pageWidth - 11, currentYPosition + 3, { align: 'right' });
        currentYPosition += 5;
        // Table Column Titles
        const headers = [
            [
                "S.No",
                "District",
                "Sub Division",
                "Block",
                "Panchayat",
                // "Date Range",
                "Name of Inspection Officer",
                "Designation",
                "Total Inspection Target",
                "Actual Inspection Carried Out",
                "Achievement %",
            ],
        ];
        // Repeat the stockData 15 times
        // const repeatedStockData = Array.from({ length: 15 }, () => stockData[0]);
        // Prepare the data rows for the table
        const rows =
            data.map((data, index) => [
                index + 1,
                capitalizeFirstLetter(data.fairPriceShopDetails.district),
                capitalizeFirstLetter(data.fairPriceShopDetails.subDivision),
                capitalizeFirstLetter(data.fairPriceShopDetails.block),
                capitalizeFirstLetter(data.fairPriceShopDetails.panchayat.trim()),
                // data.dateRange,
                formatFullName(data.fullName),
                data.designation,
                // formatNumber(data.cccc) ? formatNumber(data.cccc) : "N/A",
                0,
                formatNumber(data.count),

                `${((data.count / data.count) * 100).toFixed(2)}%`
            ]);
        const total = sortedData.reduce((acc, data) => acc + data.count, 0).toLocaleString();

        // Add the total row at the bottom
        rows.push([
            "",  // Empty column for S.No
            "Total",  // Empty column for District
            "",  // Empty column for Sub Division
            "",  // Empty column for Block
            "",  // Empty column for Panchayat
            "",  // Label for total
            "",  // Empty column for Designation
            "",  // Empty column for Total Inspection Target
            total,  // Actual Inspection Carried Out (total)
            "",  // Empty column for Achievement %
        ]);
        // AutoTable Plugin - Adding Table to PDF
        doc.autoTable({
            head: headers,
            body: rows,
            startY: currentYPosition + 10,  // Adjust position if necessary

            theme: 'grid',
            headStyles: {
                fontStyle: 'bold',  // Make the header text bold
                textColor: [12, 92, 108],  // Text color for header
                fillColor: [242, 242, 242],  // Fill color for header
                fontSize: 10,
            },

            margin: { top: 30, left: 7 },
            columnStyles: {
                0: { cellWidth: 12, halign: 'center' },
                1: { cellWidth: 16, halign: 'left' },
                2: { cellWidth: 19, halign: 'left' },
                3: { cellWidth: 15, halign: 'left' },
                4: { cellWidth: 20, halign: 'left' },
                5: { cellWidth: 25, halign: 'left' },
                6: { cellWidth: 25, halign: 'left' },
                7: { cellWidth: 21, halign: 'right' },
                8: { cellWidth: 15, halign: 'right' },
                9: { cellWidth: 25, halign: 'right' },
            },

            didParseCell: (data) => {
                // Apply background color and text color for the total row
                if (data.row.index === rows.length - 1) {  // The last row is the total row
                    data.cell.styles.fillColor = [14, 85, 108];  // Dark blue background
                    data.cell.styles.textColor = [255, 255, 255];  // White text
                    data.cell.styles.fontSize = 12;
                }
            },
        });

        // Save the PDF
        doc.save("SummaryMonthlyInspection.pdf");

    };

    const generateExcel = () => {
        // 1. Get the current date in DD-MM-YYYY format
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // 2. Generate Excel file using ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('FPS Inspection Sumary Report');

        worksheet.mergeCells('A1:J1'); // Merge cells for the title
        worksheet.getCell('A1').value = `FPS Inspection Sumary Report`; // Add spaces before date to shift it

        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        worksheet.mergeCells('A2:J2'); // Merge cells for the title
        worksheet.getCell('A2').value = `Report Date : ${formattedDateTime}`; // Add spaces before date to shift it

        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };
        worksheet.getCell('A2').font = { size: 16, bold: true, color: { argb: '00000' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        worksheet.mergeCells('A3:J3'); // Merge cells for the title
        worksheet.getCell('A3').value = `From Date: ${fromDate}                  To Date: ${toDate}`; // Add spaces before date to shift it

        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A3').font = { size: 16, bold: true, color: { argb: '00000' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        // Define the header row
        worksheet.addRow([
            "S.No",
            "District",
            "SubDivision",
            "Block",
            "Panchayat",
            //    "Date Range",

            "Name of Inspection Officer",
            "Designation",
            "Total Inspection Target",
            "Actual Inspection Carried Out",
            "Achievement %",
        ]);

        // Apply header style: bold, size 12, and orange background
        worksheet.getRow(4).font = { bold: true, size: 12 };
        worksheet.getRow(4).alignment = { horizontal: 'center' }; // Center alignment

        // Apply background color to the first 6 cells of the header row
        for (let col = 1; col <= 10; col++) {
            const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }

        // Adjust column widths
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A width
            { key: 'B', width: 20 },  // Column B width
            { key: 'C', width: 25 },  // Column C width
            { key: 'D', width: 25 },  // Column D width
            { key: 'E', width: 25 },  // Column E width
            { key: 'F', width: 30 },  // Column F width
            { key: 'G', width: 30 },  // Column G width
            { key: 'H', width: 25 },  // Column H width
            { key: 'I', width: 25 },  // Column I width
            { key: 'J', width: 35 },  // Column J width
            //    { key: 'K', width: 25 },  // Column K width
        ];

        // Add data rows
        data.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                index + 1,
                capitalizeFirstLetter(row.fairPriceShopDetails.district),
                capitalizeFirstLetter(row.fairPriceShopDetails.subDivision),
                capitalizeFirstLetter(row.fairPriceShopDetails.block),
                capitalizeFirstLetter(row.fairPriceShopDetails.panchayat.trim()),
                //    row.dateRange,
                formatFullName(row.fullName),
                row.designation,

                // formatNumber(row.ccccc) ? formatNumber(row.ccccc) : "N/A",
                0,
                formatNumber(row.count),

                `${((row.count / row.count) * 100).toFixed(2)}%`
            ]);

            // Apply center alignment for each cell in the data row (columns 1 to 6)
            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {
                    // Center alignment for S.No (serial number)
                    cell.alignment = { horizontal: 'center' };
                } else if (colNumber === 2 || colNumber === 3 || colNumber === 4 || colNumber === 5 || colNumber === 6) {
                    // Right align for fpsId (col 6), Date of Inspection (col 7), RC Number (col 8), No. of members (col 10), Mobile Number (col 11)
                    cell.alignment = { horizontal: 'left' };
                } else if (colNumber === 10 || colNumber === 9 || colNumber === 8) {  // For basic data (columns 2 to 11)

                    // Right align numeric data (other than the specific columns)
                    cell.alignment = { horizontal: 'right' };

                } else {  // For responses (columns 12 to 15)
                    if (typeof cell.value === 'string' || cell.value instanceof String) {
                        // Left align text-based data
                        cell.alignment = { horizontal: 'left' };
                    } else {
                        // Right align numeric data
                        cell.alignment = { horizontal: 'right' };
                    }
                }
            });
        });

        const total = data.reduce((acc, row) => acc + row.count, 0).toLocaleString();

        // Add the total row at the bottom of the table
        const totalRow = worksheet.addRow([
            "",  // Empty column for S.No
            "Total",  // Label for total
            "",  // Empty column for Sub Division
            "",  // Empty column for Block
            "",  // Empty column for Panchayat
            "",  // Empty column for Name of Inspection Officer
            "",  // Empty column for Designation
            "",  // Empty column for Total Inspection Target
            total,  // Actual Inspection Carried Out (total)
            "",  // Empty column for Achievement %
        ]);

        // Apply styling to the total row
        totalRow.font = { bold: true, size: 12 };
        totalRow.alignment = { horizontal: 'center' };

        // Set the background color for each cell in the total row to span all columns
        totalRow.eachCell((cell, colNumber) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply border to each cell
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } },
            };
        });

        // Save the file (Excel)
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'SummaryMonthlyInspection.xlsx';
            link.click();
        });
    };



    const handleStartDateChange = (date) => {
        setStartDate(date);       // Set the selected start date
        setEndDate('');           // Clear the end date when start date changes
        setShowCalendar(false);   // Hide the calendar after selection
        setShowTable(false);
    };


    const handleEndDateIconClick = () => {
        // Only show the calendar for endDate if startDate is selected
        if (startDate) {
            setShowEndCalendar(true);
        }
    };
    // Handle the end date change
    const handleEndDateChange = (date) => {
        setEndDate(date);
        setShowEndCalendar(false);
        setShowTable(false);
    };
    // Token you provided (for testing purposes)

    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    //const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;  // Define the base URL
    useEffect(() => {
        // console.log('Token:', token);  // Check if token is set
        if (token) {
            axios.get(`${baseUrl}/districts?pagination[pageSize]=50`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {

                        setDistricts(response.data.data);
                        const updatedDistricts = [
                            { district: 'All', districtName: 'All Districts', districtUid: null }, // 'All' option
                            ...response.data.data
                        ];

                        setDistricts(updatedDistricts); // Set the updated districts with 'All'
                    } else {
                        setError("Invalid response format");
                    }


                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);
    const fetchSubDivisions = async (districtId) => {
        if (districtId) {
            try {
                const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                // If the response data is available and valid, set the state
                setSubDivisions(response.data.data || []);
                //  console.log('Sub-Divisions:', response.data.data);  // Log response data for debugging
            } catch (error) {
                // Enhanced error logging
                if (error.response) {
                    // If the error is from the server (response with status code)
                    console.error('Error Response:', error.response);
                    setError(`Error fetching sub-divisions: ${error.response.status} ${error.response.statusText}`);
                } else if (error.request) {
                    // If the error is due to no response received
                    console.error('Error Request:', error.request);
                    setError('No response from the server');
                } else {
                    // If something went wrong setting up the request
                    console.error('Error Message:', error.message);
                    setError(`Error: ${error.message}`);
                }
            }
        } else {
            setSubDivisions([]);
        }
    };




    const fetchBlocks = async (subDivisionId) => {
        if (subDivisionId) {
            try {
                // Modify the API endpoint and include the filters for sub-division ID
                const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=50`, {
                    headers: {
                        Authorization: `Bearer ${token}`,  // Include the Authorization token if needed
                    }
                });

                // Update the state with the blocks data
                setBlocks(response.data.data || []);  // Ensure the data exists and is in the expected format
                // console.log('Blocks:', response.data.data);  // Log the response data for debugging
            } catch (error) {
                console.error('Error fetching blocks:', error);  // Improved error logging
                setError("Error fetching blocks");
            }
        } else {
            // If no sub-division is selected, reset the blocks state
            setBlocks([]);
        }
    };

    const fetchPanchayats = async (blockId) => {
        if (blockId) {
            try {
                const response = await axios.get(`${baseUrl}/panchayats?filters[block][id][$eq]=${blockId}&pagination[pageSize]=100`, {
                    headers: {
                        Authorization: `Bearer ${token}`,  // Make sure token is included if needed
                    }
                });
                setPanchayats(response.data.data || []);  // Update state with panchayats data
                // console.log('Panchayats:', response.data.data);  // Debugging the fetched data
            } catch (error) {
                console.error('Error fetching panchayats:', error);
                setError("Error fetching panchayats");
            }
        } else {
            setPanchayats([]);  // If no block selected, reset panchayats
        }
    };

    const fetchInspectionOfficers = async () => {
        try {
            // console.log('Fetching inspection officers...');
            // console.log('District UID:', districtUid);  // Check if districtUid is set correctly
            if (!districtUid) {
                setError("District UID is required.");
                return;
            }
            const apiUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api/user-posting/get-all`;
            const requestData = {};
            if (districtUid) {
                requestData.district = districtUid;
            }
            if (subDivisionUid) {
                requestData.subDivision = subDivisionUid;
            }
            if (blockUid) {
                requestData.block = blockUid;
            }

            // console.log('Request Data:', requestData);  // Debugging the request body
            const response = await axios.post(apiUrl, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // console.log('Response:', response);  // Log the full response to check for data or errors
            setInspectionOfficers(response.data);  // Set the data
            setOfficerDesignation(response.data);

        } catch (error) {
            console.error('Error:', error);  // Log full error
            if (error.response) {
                console.error('Response Error:', error.response.data);  // Log the response error
                setError(`Error: ${error.response.status} - ${error.response.data.message}`);
            } else {
                setError("An error occurred while fetching inspection officers.");
            }
        }
    };


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (districtUid) {
                fetchInspectionOfficers(); // Only call once after debounce delay
            }
        }, 100); // Delay in milliseconds

        return () => clearTimeout(timeoutId); // Cleanup timeout on effect cleanup or when dependencies change
    }, [districtUid, subDivisionUid, blockUid]); // Trigger when any of these state variables change




    const handleInspectionOfficerChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedOfficer = inspectionOfficers.find((officer) => officer.id === selectedId);
        const selectedlabelfullname = selectedOption ? selectedOption.fullName : '';
        const selectedOfficerUsername = selectedOption ? selectedOption.username : "";
        // Update the selected inspection officer id

        setInspectionOfficerId(selectedId);
        setUserName(selectedOfficerUsername);
        setId(selectedOfficer ? selectedOfficer.id : '');
        setDesignationName(''); // Reset designation when officer changes

        const officerDesignations = inspectionOfficers.filter(officer => officer.id === selectedId);

        // If only one designation exists, set it automatically
        if (officerDesignations.length === 1) {
            setOfficerDesignation(officerDesignations);
            setDesignationName(officerDesignations[0].designation); // Automatically set the designation
        } else {
            // If multiple designations exist, leave it empty for user to select
            setOfficerDesignation(officerDesignations);
        }
    };





    const handleDistrictChange = (selectedOption) => {
        const selectedDistrictId = selectedOption ? selectedOption.value : '';  // districtId for filtering
        const selectedDistrictUid = selectedOption ? selectedOption.districtUid : '';  // districtUid for reports

        // console.log('Selected District ID (for filtering):', selectedDistrictId);  // for filtering
        // console.log('Selected District UID (for report generation):', selectedDistrictUid);  // for report generation

        // Set both districtId (for filtering) and districtUid (for report generation)
        setDistrictId(selectedDistrictId);  // For filtering
        setDistrictUid(selectedDistrictUid);  // For report generation
        setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');

        // Reset everything except subdivision

        setSubDivisionId('');  // Reset sub-division
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        //  setFpsId('');  // Reset FPS ID
        //  setFPShops([]);  // Clear FPS shops
        setPanchayats([])
        setBlocks([])
        setInspectionOfficerId(''); // Clear the inspection officer ID
        setId(''); // Clear poimsUserId
        //   setInspectionDates([])
        //  setInspectionDate('')
        setShowTable(false);
        setInspectionOfficerId('');
        fetchSubDivisions(selectedDistrictId);  // Fetch subdivisions based on the selected district
        fetchInspectionOfficers(selectedDistrictId);
        setDesignationName('');
        setOfficerDesignation('');
    };

    const handleSubDivisionChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectdSubDivisionUid = selectedOption ? selectedOption.subDivisionUid : "";

        // console.log('Selected Subdivision:', selectedId);
        // Reset everything except block
        setSubDivisionUid(selectdSubDivisionUid);
        //  setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setSubDivisionId(selectedId);
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        //  setFpsId('');  // Reset FPS ID
        //setFPShops([]);  // Clear FPS shops 
        setPanchayats([]);  //it is not actved panchayats without selecting
        setBlocks([]); //it is not actved block  without selecting
        //   setInspectionDates([])
        //   setInspectionDate('')
        setInspectionOfficerId(''); // Clear the inspection officer ID
        setId(''); // Clear poimsUserId
        // setInspectionOfficerId('');
        setShowTable(false);
        fetchBlocks(selectedId);  // Fetch blocks based on the selected subdivision

        fetchInspectionOfficers(selectedId);
        setDesignationName('');
        setOfficerDesignation('');
    };

    const handleBlockChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedBlockUid = selectedOption ? selectedOption.blockUid : '';
        // console.log('Selected Block:', selectedId);
        // console.log('Selected BlockUid:', selectedBlockUid);
        // Reset everything except panchayat
        setBlockId(selectedId);
        setBlockUid(selectedBlockUid);

        setPanchayatId('');  // Reset panchayat
        setPanchayatUid('');
        //  setFpsId('');  // Reset FPS ID
        //setFPShops([]);  // Clear FPS shops without selecting
        setPanchayats([]);  //it is not actved panchayats  without selecting
        // setInspectionDates([])
        //  setInspectionDate('')
        setInspectionOfficerId('');
        setShowTable(false);
        setInspectionOfficerId(''); // Clear the inspection officer ID
        setId(''); // Clear poimsUserId
        fetchPanchayats(selectedId);
        fetchInspectionOfficers(selectedId);
        setDesignationName('');
        setOfficerDesignation('');

    };

    const handlePanchayatChange = (selectedOption) => {

        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedpanchayatUid = selectedOption ? selectedOption.panchayatUid : '';
        // console.log('Selected Panchayat:', selectedId);
        // console.log("selected panUid", selectedpanchayatUid);
        setPanchayatUid(selectedpanchayatUid);
        // Reset only FPS ID, as panchayat is selected
        setPanchayatId(selectedId);
        setId('');
        setInspectionOfficerId('');
        //  setFpsId('');  // Reset FPS ID
        // setFPShops([]);  // Clear FPS shops not accepting fps without selecting
        // setInspectionDates([])
        // setInspectionDate('')
        //   fetchFPShops(selectedId);  // Fetch FPS shops based on the selected panchayat
        setShowTable(false);
        setDesignationName('');
        setOfficerDesignation('');
    };

    // Function to clear all data (reset state)
    const handleClear = () => {
        setCurrentPage(1);
        //setFpsId('');
        setInspectionOfficerId('');
        setDistrictUid(null);
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setPanchayatId('');
        setStartDate('');
        setEndDate('');
        setShowDownloadButton(false);
        setShowTable(false);
        setDesignationName('');
        setOfficerDesignation('');
        setData([]);
    };

    const handleGenerateReport = () => {



        setIsLoading(true);
        setStockData([]);
        const formatDate = (date) => {
            if (!date) return null;



            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
            const year = date.getFullYear();
            return `${year}-${month}-${day}`;
        };



        // console.log(requestData);
        const requestData = {};

        // Add startDate and endDate to the requestData if available
        if (startDate) {
            requestData.from = formatDate(startDate);
        }

        if (endDate) {
            requestData.to = formatDate(endDate);
        }

        // Add districtId to the requestData if selected
        if (districtUid) {
            requestData.district = districtUid;
        }
        else {
            requestData.district = "All"; // Send "All" if no specific district is selected
        }

        // Add other optional parameters like subDivision, block, panchayat, fpsId
        if (subDivisionUid) {
            requestData.subDivision = subDivisionUid;
        }

        if (blockUid && blockUid.trim() !== "") {
            requestData.block = blockUid;
        }

        if (panchayatUid && panchayatUid.trim() !== "") {
            requestData.panchayat = panchayatUid;
        }

        if (poimsUserId) {
            requestData.poimsUserId = poimsUserId;
        }

        // console.log(requestData);  // Log the request data for debugging


        //  Make the POST request to fetch the report
        axios
            .post(`${process.env.REACT_APP_AUDIT_API_URL}/api/survey/reports3`, requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json', // Ensure content type is set
                },
            })
            .then((response) => {
                setIsLoading(false);
                if (response.data && response.data.length > 0) {
                    setDataAvailable(true);  // Set data flag as true
                    setData(response.data);  // Populate data
                    //  setSortedData(response.data); // Populate sorted data
                } else {
                    setDataAvailable(false);  // Set flag as false
                    setData([]);  // Clear any previous data
                    //  setSortedData([]);  // Clear sorted data
                    setError("No data available for the selected filters.");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching report.");
                setDataAvailable(false);  // Set flag to false
                setData([]);  // Clear data on error
                // setSortedData([]);  // Clear sorted data
            });

        setShowTable(true);  // This will show the table
        setShowDownloadButton(true);

    };
    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };




    const formatNumber = (number) => {
        return new Intl.NumberFormat('en-IN').format(number); // 'en-IN' for Indian number formatting (commas at appropriate positions)
    };
    // Helper function to format the date as 'YYYY-MM-DD'
    const formatDate = (date) => {
        // Ensure the date is a valid date object before formatting
        if (date instanceof Date && !isNaN(date)) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return date.toLocaleDateString('en-GB', options).split('/').reverse().join('-'); // Format: 'YYYY-MM-DD'
        }
        return ''; // Return an empty string if the date is invalid
    };

    const handleRowClick = async (username, panchayatUid) => {
        const token = `${process.env.REACT_APP_AFTER_TOKEN}`; // Assuming token is stored here
        try {
            const requestData = { username, panchayatUid }; // Add panchayatUid to the request

            if (startDate) {
                requestData.startDate = formatDate(startDate); // Ensure formatDate works correctly
            }

            if (endDate) {
                requestData.endDate = formatDate(endDate); // Fixed the typo from 'endaDate' to 'endDate'
            }

            // Make the API call with the updated payload
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/reports/fps-inspection`, requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // console.log('API response:', response.data);

            // Open the FPS Inspection report page with the relevant data
            const inspectionUrl = `/fpsInspectionReport?username=${username}&startDate=${requestData.startDate}&endDate=${requestData.endDate}&panchayatUid=${panchayatUid}`;
            window.open(inspectionUrl, '_blank');

        } catch (error) {
            console.error('Error fetching data from second API:', error);
        }
    };





    return (
        <div className="summaryOfinsepectionreport" ref={reportRef}>
            <div className="summaryOfinsepection-card">
                <div className="summaryOfinsepection-card-header">Summary of Inspection Report</div>
                <div >
                    <div className="summaryOf-mainBlock">
                        <div className="summaryOfform-group-cu">
                            <label htmlFor="district" className="textitems"><span className="asterisk">*</span>District</label>

                            {/* Replace select with react-select */}
                            <Select
                                className="search-select"
                                id="district"
                                // Ensure you pass the selected option as an object with value and label
                                value={districts.find((dist) => dist.id === districtId) ? {
                                    value: districts.find((dist) => dist.id === districtId).id,
                                    label: capitalizeFirstLetter(districts.find((dist) => dist.id === districtId).districtName)
                                } : null}
                                onChange={handleDistrictChange}  // Handle the selection change
                                options={districts.sort((a, b) => a.districtName.localeCompare(b.districtName)).map((dist) => ({
                                    value: dist.id,
                                    label: capitalizeFirstLetter(dist.districtName),
                                    districtUid: dist.districtUid
                                }))}
                                placeholder="Select a district"
                                isSearchable // Enable search in the dropdown
                                styles={customStyles} // Apply custom styles here
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown} // Trigger dropdown open
                                onMenuClose={toggleDropdown} // Trigger dropdown close
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />

                        </div>
                        <div className="summaryOfform-group-cu">
                            <label htmlFor="subDivision">{/*<span className="asterisk">*</span>*/}Sub Division</label>
                            <Select
                                className="search-select"
                                id="subDivision"
                                value={subDivisionId ? {
                                    value: subDivisionId,
                                    label: capitalizeFirstLetter(subDivisions.find((sub) => sub.id === subDivisionId)?.subDivisionName)
                                } : null}
                                onChange={handleSubDivisionChange}
                                options={subDivisions.sort((a, b) => a.subDivisionName.localeCompare(b.subDivisionName)).map((sub) => ({
                                    value: sub.id,
                                    label: capitalizeFirstLetter(sub.subDivisionName),
                                    subDivisionUid: sub.subDivisionUid,
                                }))}
                                placeholder="Select Sub Division"
                                isSearchable
                                styles={customStyles}
                                // required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                // menuIsOpen={isOpen} 
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px", }}>

                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                        <div className="summaryOfform-group-cu">
                            <label htmlFor="block" className="textitems-2">{/*<span className="asterisk">*</span>*/}Block</label>
                            <Select
                                className="search-select"
                                id="block"
                                value={blockId ? {
                                    value: blockId,
                                    label: capitalizeFirstLetter(blocks.find((block) => block.id === blockId)?.blockName)
                                } : null}
                                onChange={handleBlockChange}
                                options={blocks.sort((a, b) => a.blockName.localeCompare(b.blockName)).map((block) => ({
                                    value: block.id,
                                    label: capitalizeFirstLetter(block.blockName),
                                    blockUid: block.blockUid,
                                }))}
                                placeholder="Select Block"
                                isSearchable
                                styles={customStyles}
                                // required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                    </div>
                    <div className="summaryOf-mainBlock">
                        <div className="summaryOfform-group-cu">
                            <label htmlFor="panchayat">{/*<span className="asterisk">*</span>*/}Panchayat</label>
                            <Select
                                className="search-select"
                                id="panchayat"
                                value={panchayatId ? {
                                    value: panchayatId,
                                    label: capitalizeFirstLetter(panchayats.find((p) => p.id === panchayatId)?.panchayatName)
                                } : null}
                                onChange={handlePanchayatChange}
                                options={panchayats.sort((a, b) => a.panchayatName.localeCompare(b.panchayatName)).map((p) => ({
                                    value: p.id,
                                    label: capitalizeFirstLetter(p.panchayatName),
                                    panchayatUid: p.panchayatUid,
                                }))}
                                placeholder="Select Panchayat"
                                isSearchable
                                styles={customStyles}
                                // required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </div>
                                    ),
                                }}
                            />
                        </div>

                        <div className="summaryOfform-group-cu" >
                            <label htmlFor="fps" className="textitems-1">{/*<span className="asterisk">*</span>*/}Inspection Officer</label>
                            <Select
                                className="search-select"
                                id="inspectionOfficer"
                                value={inspectionOfficerId ? {
                                    value: inspectionOfficerId,
                                    label: formatFullName(
                                        inspectionOfficers.find((officer) => officer.id === inspectionOfficerId)?.fullname
                                    )
                                } : null}
                                onChange={handleInspectionOfficerChange}
                                // options={inspectionOfficers.map((officer) => ({
                                options={inspectionOfficers.sort((a, b) => a.fullname.localeCompare(b.fullname)).map((officer) => ({
                                    value: officer.id, // Use officer's id as value
                                    label: formatFullName(officer.fullname),
                                    username: officer.username,
                                    poimsUserId: officer.id,

                                }))}
                                placeholder="Select Inspection Officer"
                                isSearchable
                                styles={customStyles}
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </div>
                                    ),
                                }}
                            />



                        </div>
                        <div className="summaryOfform-group-cu">
                            <label htmlFor="startDate" className="textitems-1"> {/*<span className="asterisk">*</span>*/}  Designation</label>
                            <Select
                                className="search-select"
                                id="designation"
                                placeholder="Select Designation"
                                value={designationName ? {
                                    value: designationName,
                                    label: formatFullName(
                                        officerDesignation.find((officer) => officer.designation === designationName)?.designation
                                    )
                                } : null}
                                onChange={(selectedOption) => setDesignationName(selectedOption ? selectedOption.value : '')}
                                options={Array.isArray(officerDesignation) ?
                                    officerDesignation.map((officer) => ({
                                        value: officer.designation,
                                        label: formatFullName(officer.designation),
                                        username: officer.fullname,
                                        poimsUserId: officer.id,
                                        designation: officer.designation
                                    })) : []
                                }
                                isSearchable
                                styles={customStyles}
                                // required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />


                        </div>
                    </div>
                    <div className="summaryOf-mainBlock">
                        <div className="summaryOfform-group-cu-1">
                            <label htmlFor="startDate" className=" "><span className="asterisk">*</span>From Date</label>
                            <div className="summaryOf-setting-stock-repo">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="summaryOf-input-repo"
                                    value={startDate ? format(startDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowCalendar(true)}
                                    required
                                />
                                <div className="summaryOf-icon-test-stock-repo" onClick={() => setShowCalendar(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showCalendar && (
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        dateFormat="DD-MM-YYYY"
                                        //  showMonthYearPicker 
                                        onClickOutside={() => setShowCalendar(false)}
                                        inline
                                        minDate={minStartDate} // From January 1st of current year
                                        maxDate={currentDate} // Today
                                    />
                                )}
                            </div>
                        </div>


                        <div className="summaryOfform-group-cu-2">
                            <label htmlFor="startDate" className=" "><span className="asterisk">*</span>To Date</label>
                            <div className="summaryOf-setting-stock-repo">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="summaryOf-input-repo"
                                    value={endDate ? format(endDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowEndCalendar(true)}
                                    required
                                    disabled={!startDate}
                                />
                                <div className="summaryOf-icon-test-stock-repo" onClick={handleEndDateIconClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showEndCalendar && (
                                    <DatePicker
                                        selected={endDate}
                                        onChange={handleEndDateChange} // Updates endDate when a new date is selected
                                        // onChange={(date) => {
                                        //     setEndDate(date);
                                        //     setShowEndCalendar(false);

                                        // }}
                                        dateFormat="DD-MM-yyyy"  // Display in Month-YYYY format
                                        //  showMonthYearPicker
                                        // showMonthYearPicker={false}
                                        onClickOutside={() => setShowEndCalendar(false)}
                                        minDate={startDate} // End date can't be before the start date
                                        maxDate={currentDate} // End date can't be after today

                                        inline
                                    />
                                )}
                            </div>
                        </div>

                        <div className="summaryOf-group-cu-testing-2-stock-repo-btn">
                            {/* Conditionally Render GET REPORT Button */}
                            <div className="summaryOf-group-cu-testing-2-stock-repo">
                                <button className="summaryOf-btn-test-stock-repo" onClick={handleClear}
                                    disabled={!((districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))}

                                >CLEAR
                                </button>
                            </div>
                            <div className="summaryOf-group-cu-testing-2-stock-repo">
                                <button
                                    className="summaryOf-btn-test-stock-repo"
                                    onClick={handleGenerateReport}

                                    disabled={!((districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))}
                                >
                                    GENERATE REPORT
                                </button>
                            </div>


                            {/* Conditionally Render DOWNLOAD PDF Button */}
                            {startDate && endDate && showDownloadButton && showTable && dataAvailable && (
                                <div className="summaryOf-group-cu-testing-stock-repo">
                                    <button onClick={generatePDF} className="summaryOf-btn-test-stock-repo-pd">
                                        DOWNLOAD PDF
                                    </button>
                                    <button onClick={generateExcel} className="summaryOf-btn-test-stock-repo-px">
                                        DOWNLOAD XLSX
                                    </button>
                                </div>
                            )}
                        </div>

                    </div>
                </div>




            </div>

            <div className="summaryOf-main-repo">
                <table className="summaryOf-table-repo">
                    <thead>
                        <tr>
                            <th rowSpan="2">S.No.</th>
                            <th rowSpan="2">District</th>
                            <th rowSpan="2">SubDivision</th>
                            <th rowSpan="2">Block</th>
                            <th rowSpan="2">Panchayat</th>
                            <th rowSpan="2">Name of Inspection Officer</th>
                            <th rowSpan="2">Designation</th>
                            <th rowSpan="2">Total Inspection Target</th>
                            <th rowSpan="2">Actual Inspection Carried Out</th>
                            <th rowSpan="2">Achievement %</th>
                        </tr>
                    </thead>
                    {showTable && (
                        <tbody className="summary-tbody">
                            {isLoading ? (
                                <tr>
                                    <td colSpan="14" style={{ textAlign: 'center' }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) : sortedData.length > 0 ? (
                                <>
                                    <tr style={{ backgroundColor: ' #2a6d8b' }}>
                                        <td colSpan="8" style={{ textAlign: 'center', fontWeight: 'bold', color: 'white' }}>
                                            Total
                                        </td>
                                        <td style={{ fontWeight: 'bold', color: 'white' }}>
                                            {sortedData.reduce((acc, data) => acc + data.count, 0).toLocaleString()}
                                        </td>
                                        <td></td>
                                    </tr>
                                    {currentRecords.map((data, index) => {
                                        // const panchayat = panchayats.find(p => p.id === data.fairPriceShopDetails.panchayatId);
                                        // const panchayatUid = panchayat ? panchayat.panchayatUid : null;

                                        return (
                                            <tr
                                                key={index}
                                                onClick={() => {
                                                    const username = data.username;
                                                    const panchayatUid = data.fairPriceShopDetails.panchayatUid
                                                    if (username && panchayatUid) {
                                                        handleRowClick(username, panchayatUid);
                                                    } else {
                                                        console.warn('No username found for this row.');
                                                    }
                                                }}
                                            >
                                                <td>{indexOfFirstRecord + index + 1}</td>
                                                <td>{capitalizeFirstLetter(data.fairPriceShopDetails.district)}</td>
                                                <td>{capitalizeFirstLetter(data.fairPriceShopDetails.subDivision)}</td>
                                                <td>{capitalizeFirstLetter(data.fairPriceShopDetails.block)}</td>
                                                <td>{capitalizeFirstLetter(data.fairPriceShopDetails.panchayat.trim())}</td>
                                                <td>{formatFullName(data.fullName)}</td>
                                                <td>{data.designation}</td>
                                                <td>0</td>
                                                <td>{formatNumber(data.count)}</td>
                                                <td>{((data.count / data.count) * 100).toFixed(2)}%</td>
                                            </tr>
                                        );
                                    })}

                                </>
                            ) : (
                                <tr>
                                    <td colSpan="11" style={{ textAlign: 'center', color: 'red' }}>
                                        No Data Available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>


            </div>
            {/* Pagination Controls */}
            <div className="pagination-controls">
                <button
                    className="pagination-btn"
                    onClick={prevPage}
                    disabled={currentPage === 1 || sortedData.length === 0}
                    style={{ padding: '5px 10px', margin: '10px' }}
                >
                    Previous
                </button>
                <span style={{ margin: '10px' }}>
                    Page {currentPage} of {Math.ceil(sortedData.length / recordsPerPage)}
                </span>
                <button
                    className="pagination-btn"
                    onClick={nextPage}
                    disabled={currentPage === Math.ceil(sortedData.length / recordsPerPage) || sortedData.length === 0}
                    style={{ padding: '5px 10px', margin: '10px' }}
                >
                    Next
                </button>
            </div>
        </div>
    );
}
export default SummaryOfMonthly;